import { AbstractModel, DateFormatConstants, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import moment from 'moment-timezone';

@inheritSerialization(AbstractModel)
export class RideEstimate extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  description: string;

  @autoserialize
  rideRequestId: number;

  @autoserializeAs(Date)
  estimatedDriverTimeOfArrival: Date;

  @autoserializeAs(Date)
  driverTimeOfArrivalEstimatedAt: Date;

  @autoserializeAs(Date)
  estimatedRiderTimeOfDropoff: Date;

  @autoserializeAs(Date)
  riderTimeOfDropoffEstimatedAt: Date;

  @autoserialize
  timeZone: string;

  static OnSerialized(instance: RideEstimate, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.estimatedDriverTimeOfArrival)) {
      json.estimatedDriverTimeOfArrival = moment.utc(instance.estimatedDriverTimeOfArrival).format(DateFormatConstants.ISO_LOCAL_DATE);
    }

    if (!isNullOrUndefined(instance.driverTimeOfArrivalEstimatedAt)) {
      json.driverTimeOfArrivalEstimatedAt = moment.utc(instance.driverTimeOfArrivalEstimatedAt).format(DateFormatConstants.ISO_LOCAL_DATE);
    }

    if (!isNullOrUndefined(instance.estimatedRiderTimeOfDropoff)) {
      json.estimatedRiderTimeOfDropoff = moment.utc(instance.estimatedRiderTimeOfDropoff).format(DateFormatConstants.ISO_LOCAL_DATE);
    }

    if (!isNullOrUndefined(instance.riderTimeOfDropoffEstimatedAt)) {
      json.riderTimeOfDropoffEstimatedAt = moment.utc(instance.riderTimeOfDropoffEstimatedAt).format(DateFormatConstants.ISO_LOCAL_DATE);
    }
  }

  static OnDeserialized(instance: RideEstimate, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['estimatedDriverTimeOfArrival'])) {
      instance.estimatedDriverTimeOfArrival = moment(json['estimatedDriverTimeOfArrival']).toDate();
    }

    if (!isNullOrUndefined(json['driverTimeOfArrivalEstimatedAt'])) {
      instance.driverTimeOfArrivalEstimatedAt = moment(json['driverTimeOfArrivalEstimatedAt']).toDate();
    }

    if (!isNullOrUndefined(json['estimatedRiderTimeOfDropoff'])) {
      instance.estimatedRiderTimeOfDropoff = moment(json['estimatedRiderTimeOfDropoff']).toDate();
    }

    if (!isNullOrUndefined(json['riderTimeOfDropoffEstimatedAt'])) {
      instance.riderTimeOfDropoffEstimatedAt = moment(json['riderTimeOfDropoffEstimatedAt']).toDate();
    }
  }
}
